import useNTGroupAthletesFormGrid from './UseNTGroupAthletesFormGrid';

import { SORT_TYPES } from '@usas/ui-web/components/table/utils/TableConstants';
import { Icon, Table, Td, Th, Tr } from '@usas/ui-web/components/table/Table';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import useTableData from '@usas/ui-web/state/table/UseTableData';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import { formatTimeForDisplay } from '@usas/ui-web/utils/TimesUtils';

const NestedTable = ({ data }) => (
  <Table.Nested>
    <thead>
      <tr>
        <th>Event</th>
        <th>Swim Time</th>
        <th>Swim Date</th>
        <th>Meet Name</th>
      </tr>
    </thead>
    <Table.NestedBody data={data} colSpan={4} noDataText='No Events'
      renderRow={(swimEvent, i) =>
        <tr key={i}>
          <td>{swimEvent.eventName || ''}</td>
          <td>{swimEvent.swimTime ? formatTimeForDisplay(swimEvent.swimTime) : ''}</td>
          <td>{swimEvent.swimDate ? formatDate(swimEvent.swimDate) : ''}</td>
          <td>{swimEvent.meetName || ''}</td>
        </tr>
      } />
  </Table.Nested>
);

const TableTopRow = ({ dataTotal, isLoading, onAddClicked }) => {
  const { tableState } = useTableData();

  return (
    <Tr.Top colSpan={4} showDataTotal={isLoading !== true} dataName='Athletes' dataTotal={dataTotal}>
      {tableState.selectedIds.length > 0
        ? <ActionIntraPageButton onClick={(e) => onAddClicked(e, tableState.selectedIds)}>Invite Selected Athletes ({tableState.selectedIds.length})</ActionIntraPageButton>
        : <PrimaryButton isDisabled={true} onClick={(e) => onAddClicked(e, tableState.selectedIds)}>Invite Selected Athletes</PrimaryButton>
      }
    </Tr.Top>
  );
};

const NTGroupAthletesFormGrid = ({ gridData, isLoading, onEditClicked, onDeleteClicked, onSubmitFormCallback }) => {
  const {
    formGridState,
    excludedIdsState,
    onInviteSelectedClicked
  } = useNTGroupAthletesFormGrid(gridData, onSubmitFormCallback);

  return (
    <Table.ContextWrapper data={isLoading ? [] : formGridState} rowIdKey={'personNationalTeamGroupId'} >
      <Table.Large>
        <thead>
          <TableTopRow dataTotal={formGridState.length} isLoading={isLoading} onAddClicked={onInviteSelectedClicked} />
          <tr>
            <Th.Input>
              {formGridState.some(groupAthlete => groupAthlete.canSelect) && <Icon.SelectAll excludedIds={excludedIdsState} />}
            </Th.Input>
            <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
            <Th.Sort sortKey={'inviteStatus'} sortType={SORT_TYPES.ALPHABETICAL}>Invite Status</Th.Sort>
            <Th.Action>
              <Icon.ExpandAll />
            </Th.Action>
          </tr>
        </thead>
        <Table.Body colSpan={4} isLoading={isLoading} noDataText='No Group Athletes'
          renderRow={(groupAthlete, i) =>
            <Tr.Accordion key={i} rowId={groupAthlete.personNationalTeamGroupId} tableColSpan={4} nestedTable={<NestedTable data={groupAthlete.events} />}>
              <Td.Input>
                {groupAthlete.canSelect && <Icon.Select rowId={groupAthlete.personNationalTeamGroupId} />}
              </Td.Input>
              <td style={{ fontWeight: 'bold' }}><a onClick={(e) => onEditClicked(e, groupAthlete)}>{groupAthlete.groupAthleteName || ''}</a></td>
              <td>{groupAthlete.inviteStatus || ''}</td>
              <Td.Action>
                <Icon.Delete onClick={(e) => onDeleteClicked(e, groupAthlete)} />
                <Icon.Expand rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Action>
            </Tr.Accordion>
          } />
      </Table.Large>
      <Table.Small>
        <thead>
          <TableTopRow dataTotal={formGridState.length} isLoading={isLoading} onAddClicked={onInviteSelectedClicked} />
          <tr>
            <Th.Input>
              {formGridState.some(groupAthlete => groupAthlete.canSelect) && <Icon.SelectAll excludedIds={excludedIdsState} />}
            </Th.Input>
            <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
            <Th.Sort sortKey={'inviteStatus'} sortType={SORT_TYPES.ALPHABETICAL}>Invite Status</Th.Sort>
            <Th.Action>
              <Icon.ExpandAll />
            </Th.Action>
          </tr>
        </thead>
        <Table.Body colSpan={4} isLoading={isLoading} noDataText='No Group Athletes'
          renderRow={(groupAthlete, i) =>
            <Tr.Accordion key={i} rowId={groupAthlete.personNationalTeamGroupId} tableColSpan={4} nestedTable={<NestedTable data={groupAthlete.events} />}>
              <Td.Input>
                {groupAthlete.canSelect && <Icon.Select rowId={groupAthlete.personNationalTeamGroupId} />}
              </Td.Input>
              <td style={{ fontWeight: 'bold' }}><a onClick={(e) => onEditClicked(e, groupAthlete)}>{groupAthlete.groupAthleteName || ''}</a></td>
              <td>{groupAthlete.inviteStatus || ''}</td>
              <Td.Action>
                <Icon.Delete onClick={(e) => onDeleteClicked(e, groupAthlete)} />
                <Icon.Expand rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Action>
            </Tr.Accordion>
          } />
      </Table.Small>
    </Table.ContextWrapper>
  );
};

export default NTGroupAthletesFormGrid;